import type { CampaignPlacement } from "../../../../shared/types/campaign-card.type";

export type PlacementShare = {
	placement: CampaignPlacement;
	sharePct: number;
};

export type PlacementShareOptions = {
	/** Distribute strictly by cost; empty bar when cost is 0 (GEO + Ad Group flow). */
	costOnly?: boolean;
};

/** Share of each placement within a GEO / Ad Group (100% bar width). */
export function getPlacementShares(
	placements: CampaignPlacement[],
	options: PlacementShareOptions = {},
): PlacementShare[] {
	if (!placements.length) return [];

	const costTotal = placements.reduce((sum, p) => sum + p.metrics.cost, 0);

	if (options.costOnly) {
		if (costTotal <= 0) {
			return placements.map((placement) => ({ placement, sharePct: 0 }));
		}
		return placements.map((placement) => ({
			placement,
			sharePct: (placement.metrics.cost / costTotal) * 100,
		}));
	}

	const imprTotal = placements.reduce((sum, p) => sum + p.metrics.impr, 0);
	const useImpressions = costTotal <= 0 && imprTotal > 0;
	const total = useImpressions ? imprTotal : costTotal;

	if (total <= 0) {
		const equalShare = 100 / placements.length;
		return placements.map((placement) => ({
			placement,
			sharePct: equalShare,
		}));
	}

	return placements.map((placement) => {
		const value = useImpressions
			? placement.metrics.impr
			: placement.metrics.cost;
		return {
			placement,
			sharePct: (value / total) * 100,
		};
	});
}
